<!--拜访列表 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">任务类型</div>
                <el-select v-model="searchData.TasksType" class="search-item" size="small" clearable filterable @visible-change="typeVisibleChange($event)">
                    <el-option value label="全部"></el-option>
                    <el-option v-for="item in tasksTypeList" :label="item.AttrName" :key="item.AttrValue" :value="item.AttrValue"></el-option>
                </el-select>
                <div class="search-name">状态</div>
                <el-select v-model="searchData.State" class="search-item" size="small" clearable>
                   <el-option v-for="item in stateList" :label="item.label" :key="item.value" :value="item.value"></el-option>
                </el-select>
                <div class="search-name">任务时间</div>
                <el-date-picker
                    v-model="dateTimes"
                    type="daterange"
                    align="right"
                    unlink-panels
                    size="small"
                    class="search-item" 
                    style="width:250px;"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleChange"
                    :clearable="false"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="editTask(0)" v-if="permission.add">{{ permission.add }}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" border :data="tableData" ref="multipleTable" style="width: 100%">
                <el-table-column prop="OrderCode" label="任务单号" width="180"> </el-table-column>
                <el-table-column prop="TasksTypeName" label="任务类型" width="80"> </el-table-column>
                <el-table-column prop="Follower" label="跟进人" width="80"> </el-table-column>
                <el-table-column prop="StartTimeStr" label="任务开始时间" width="180"> </el-table-column>
                <el-table-column prop="EndTimeStr" label="任务结束时间" width="180"> </el-table-column>
                <el-table-column prop="VisitsCount" label="拜访数" width="80"> </el-table-column>
                <el-table-column prop="VisitedCount" label="已拜访数" width="80"> </el-table-column>
                <el-table-column prop="UnVisitsCount" label="未拜访数" width="80">
                    <template slot-scope="scope"> {{ scope.row.VisitsCount - scope.row.VisitedCount }}</template>
                </el-table-column>
                <el-table-column prop="OrderState" label="当前状态" width="80">
                    <template slot-scope="scope">
                        <div>
                            <span v-if="scope.row.VisitsCount != scope.row.VisitedCount">
                                未完成
                            </span>
                            <span style="color: #04784b;" v-if="(scope.row.VisitsCount = scope.row.VisitedCount)">
                                已完成
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" width="250"> </el-table-column>
                <el-table-column prop="FinishTiem" label="完成时间" width="180"></el-table-column>
                <el-table-column prop="Creator" label="创建人" width="80"> </el-table-column>
                <el-table-column prop="UpdateTime" label="更新时间" width="180"> </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="180"> </el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.edit && scope.row.VisitsCount != scope.row.VisitedCount"
                                title="编辑"
                                size="mini"
                                type="text"
                                @click="editTask(1, scope.row)"
                                >{{ permission.edit }}</el-button
                            >
                            <el-button
                                v-if="permission.del && scope.row.VisitsCount != scope.row.VisitedCount"
                                title="删除"
                                size="mini"
                                type="text"
                                @click="delTask(scope.row)"
                                style="color: red;"
                                >{{ permission.del }}</el-button
                            >
                            <el-button title="任务详情" size="mini" type="text" @click="checkTask(scope.row)">任务详情</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            title="任务搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-order-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="任务单号">
                        <el-input size="small" v-model.trim="searchData.TasksCode" v-filter-special-char="searchData.TasksCode" placeholder="任务单号"></el-input>
                    </el-form-item>
                    <el-form-item label="任务类型">
                        <el-select v-model="searchData.TasksType" style="width: 100%" size="small" clearable filterable @visible-change="typeVisibleChange($event)">
                            <el-option value label="全部"></el-option>
                            <el-option v-for="item in tasksTypeList" :label="item.AttrName" :key="item.AttrValue" :value="item.AttrValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :label="item.label" :key="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跟进人">
                        <el-select v-model="searchData.Follower" size="small" style="width: 100%" filterable placeholder="请选择" clearable filterable @visible-change="followerVisibleChange($event)">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="任务时间">
                        <el-date-picker
                            v-model="dateTimes"
                            type="daterange"
                            align="right"
                            unlink-panels
                            size="small"
                            style="width: 100%"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="handleChange"
                            :clearable="false"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            permission: {},
            tasksTypeList: [],
            stateList: [
                {
                    value: '-1',
                    label: '全部'
                },
                {
                    value: '0',
                    label: '未完成'
                },
                {
                    value: '1',
                    label: '已完成'
                }
            ],
            searchData: {
                TasksCode: '',
                TasksType: '',
                State: '',
                Follower: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            dateTimes: [],
            selectDate: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ],
                onPick: ({ maxDate, minDate }) => {
                    this.selectDate = minDate.getTime();
                    if (maxDate) {
                        this.selectDate = '';
                    }
                },
                disabledDate: time => {
                    if (this.selectDate !== '') {
                        const one = 30 * 24 * 3600 * 1000;
                        const minTime = this.selectDate - one;
                        const maxTime = this.selectDate + one;
                        return time.getTime() < minTime || time.getTime() > maxTime;
                    }
                }
            },
            SIdList: [],
            dialogSearchVisible: false,
            tableData: [],
            tableDataLength: 0
        };
    },
    created() {},
    mounted() {
        let that = this;
        that.getTableData();
        that.permission = that.$util.getPermission('visitsTask');
    },
    methods: {
        handleSearch() {
            this.getTableData();
        },
        resetSearch() {
            (this.searchData = {
                TasksCode: '',
                TasksType: '',
                State: '',
                Follower: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            }),
                (this.dateTimes = []);
            this.$refs.multipleTable.clearSelection();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        followerVisibleChange(){
            let that = this;
            if (event && (!that.SIdList || that.SIdList.length == 0)) {
                that.getSIdList();
            }
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        typeVisibleChange(event) {
            let that = this;
            if (event && (!that.typeVisible || that.typeVisible.length == 0)) {
                that.getTaskTypeList();
            }
        },
        getTaskTypeList() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpAttrDatas?attrCode=tasksType'
                })
                .then(res => {
                    if (res.data) {
                        this.tasksTypeList = res.data;
                        this.tasksTypeList.push({ AttrCode: 'tasksType', AttrName: '助力外拓', AttrValue: '255' });
                    } else {
                        this.tasksTypeList = [];
                    }
                });
        },
        showSearchDialog() {
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
        },
        getTableData() {
            let that = this;
            this.$util
                .axiosPost({
                    url: '/api/EntpCustomers/GetVisitingTasksList',
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .finally(() => {});
        },
        editTask(row, type) {
            this.$router.push(`/custManage/visitingTasks/edit?id=${row ? row.Id : ''}&type=${type}`);
        },
        delTask(row) {
            if (row.VisitsCount == row.VisitedCount) {
                this.$util.warningMsg('任务已完成，不可删除！');
                return;
            }
            let that = this;
            that.$confirm('确定要删除该任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: `/api/EntpCustomers/DelVisitTasks?TaskId=${row.Id}`
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('删除成功！');
                            that.getTableData();
                        }
                    });
            });
        },
        checkTask(event) {
            if (event) {
                this.$router.push(`/custManage/visitingTasks/edit?id=${event.Id}&type=2`);
            }
        }
    }
};
</script>
<style lang="less" scoped>
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
